export const END_POINTS = {
  login: "auth/login",
  ForgetPassword: "request-password-reset",
  resetPassword: "reset-password",
  loggedInResetPassword: "loged-reset-password",
  partnerData: "reports/supply-partner-list",
  partnerTableData: "reports/supply-partner-data",
  dealsTableData: "deals/deal-list",
  compDealsTableData: "deals/deal-list-comp",
  heatMapData: "heatMap/heat-map-list",
  createDeal: "deals/create-deal",
  usersTableData: "users/users-list",
  createUser: "users/create-user",
  deleteUser: "users/delete-user",
  getUserById: "users/get-user-by",

  partnersTableData: "partners/partners-list",
  createPartner: "partners/create-partner",
  deletePartner: "partners/delete-partner",
  getPartnerById: "partners/get-partner-by",

  updateUser: "users/update-user",
  updateUserStatus: "users/update-user-status",
  updateDealStatus: "deals/update-deal-status",
  deleteDeal: "deals/delete-deal",
  partnerList: "dropdown/supply-partner-list",
  dealsList: "deal-list-dp",
  mapNewDeals: "create/map-deal-dp",
  mapAgency: "deals/map-agency",
  mapBrand: "deals/map-brand",
  mapCountry: "deals/map-country",
  clientList: "dropdown/client-list",
  dspList: "dropdown/dsp-list",
  mapdealListing: "map-deals-list",
  segmentRequestListing: "segment-request-list",
  createSegmentRequest: "create-segment-request",
  updateSegmentRequestStatus: "segment-request/update-status",
  createMapDeal: "create/map-deal",
  deleteMapDeal: "delete/map-deal",
  updateMapDealStatus: "map-deal/status",
  dealCodeList: "deal-code-list",
  userRoleList: "dropdown/user-type-list",
  reportGraph: "reports/graphs",
  expandGraph: "reports/expanded-graphs",
  changeUserPwByAdmin: "reset-password-by-admin",
  updateDealMargin: "map-deal/update-deal-margin",
  monthList: "getMonth",
  uploadCsv: "upload-csv",
  compareCsv: "compare-csv",
  csvDemandPartner: "dropdown/csv-demand-partner",
  csvSupplyPartner: "dropdown/csv-supply-partner",
  csvBrandPartner: "dropdown/csv-brand-partner",
  csvAgencyPartner: "dropdown/csv-agency-partner",

  supplyPartnerList: "supply-partner/listing",
  createSupplyPartner: "supply-partner/create",
  supplyPartnerStatus: "update-supply-partner-status",
  getPartnerById: "supply-partner/getById",
  updateSupplyPartner: "supply-partner/update-supply-partner",

  demandPartnerTableList: "demand-partner/listing",
  createDemandPartner: "demand-partner/create",
  updateDemandPartner: "demand-partner/update-demand-partner",
  demandPartnerStatus: "demand-partner/update-demand-status",
  getDemandPartnerById: "demand-partner/getById",

  agencyPartnerTableList: "agency-partner/listing",
  createAgencyPartner: "agency-partner/create",
  updateAgencyPartner: "agency-partner/update-agency-partner",
  agencyPartnerStatus: "agency-partner/update-agency-status",
  getAgencyPartnerById: "agency-partner/getById",

  brandPartnerTableList: "brand-partner/listing",
  createBrandPartner: "brand-partner/create",
  updateBrandPartner: "brand-partner/update-brand-partner",
  brandPartnerStatus: "brand-partner/update-brand-status",
  getBrandPartnerById: "brand-partner/getById",

  reportDemandPartnerList: "reports/demand-partner-table-data",
  reportDemandPartnerCardData: "reports/demand-partner-card-data",
  reportDemandPartnerGraph: "reports/demand-partner-graphs",
  reportDemandExpandedGraph: "reports/expanded-demand-partner-graphs",

  reportAgencyPartnerList: "reports/agency-partner-table-data",
  reportAgencyPartnerCardData: "reports/agency-partner-card-data",
  reportAgencyPartnerGraph: "reports/agency-partner-graphs",
  reportAgencyExpandedGraph: "reports/expanded-agency-partner-graphs",

  reportBrandPartnerList: "reports/brand-partner-table-data",
  reportBrandPartnerCardData: "reports/brand-partner-card-data",
  reportBrandPartnerGraph: "reports/brand-partner-graphs",
  reportBrandExpandedGraph: "reports/expanded-brand-partner-graphs",

  demandPartnerList: "dropdown/demand-partner-list",

  privilegeList: "dropdown/privilege-list",

  mapDealDemandFromTable: "map-deal/map-dp",

  agencyList: "agency-list",
  brandList: "brand-list",

  adomainList: "adomain-list",

  suggestionsTableData: "suggestions/suggestions-list",
  suggestionCategoryListData: "suggestions/category-list",
  createSuggestion: "suggestions/create-suggestions",
  updateSuggestion: "suggestions/update-suggestions",
  getSuggestionById: "suggestions/get-suggestions-by",
  updateSuggestionStatus: "suggestions/update-suggestions-status",
  randomSuggestions: "suggestions/random-suggestions",

  dspsTableData: "segments/dsp/dsp-list",
  getDspById: "segments/dsp/get-dsp-by",
  updateDspStatus: "segments/dsp/update-dsp-status",
  updateDsp: "segments/dsp/update-dsp",
  createDsp: "segments/dsp/create-dsp",

  geosTableData: "segments/geo/geo-list",
  updateGeoStatus: "segments/geo/update-geo-status",
  updateGeoSegmentStatus: "segments/geo/update-geo-segment-status",

  publisherssTableData: "segments/publishers/publishers-list",
  topPublishersList: "segments/publishers/top-publishers-list",
  getPublishersById: "segments/publishers/get-publishers-by",
  updatePublishersStatus: "segments/publishers/update-publishers-status",
  updatePublishers: "segments/publishers/update-publishers",
  createPublishers: "segments/publishers/create-publishers",
  deletePublishers: "segments/publishers/delete-publishers",

  segmentssTableData: "segments/segments/segments-list",
  getSegmentsById: "segments/segments/get-segments-by",
  updateSegmentsStatus: "segments/segments/update-segments-status",
  updateSegments: "segments/segments/update-segments",
  createSegments: "segments/segments/create-segments",
  deleteSegments: "/segments/segments/delete-segments",

  assignSegmentRequest: "/segment-request/assign-reqest",

  reachTableData: "segments/reach/reach-list",
  getReachById: "segments/reach/get-reach-by",
  updateReachStatus: "segments/reach/update-reach-status",
  updateReach: "segments/reach/update-reach",
  createReach: "segments/reach/create-reach",
  deleteReach: "segments/reach/delete-reach",

  countryList: "country-list",
  supplyPartnerCountryList: "supply-partner-country-list",
  dealsSupplyCountryList: "deals-supply-country-list",

  publishersList: "ai/publisher-sites",
  addSisterDomains: "ai/add-sister-domains",
};
